import '@css/app.css'
import { initConsent } from '@kraftwerkdesign/consent'
import { consentConfig } from './consent.config'
import '@js/app.ts'

initConsent(consentConfig)
